<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const handleNextStep = async () => {
  await handleNext('tutorial_find_planet')
}

const goToMap = () => {
  router.push('/map')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        Great job with zooming!
      </p>
      <p class="pb-2">
        With all that moving around on the map you might have lost sight on where our home world is. Lets find it!
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click the vertical Planets tab. In the side panel, click your home world once to auto-focus the map.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">
        Open Map
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I've found our planet!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>